import { serverBaseUrl } from "../constants/Constants";
import { getCookieToken } from "./utils";

/**
 * Fetch a protected screen-listen asset and return an object URL for <audio> / <img>.
 * Caller must URL.revokeObjectURL when done.
 */
export async function fetchScreenListenAssetBlobUrl(relativeEndpoint) {
  const token = getCookieToken();
  const res = await fetch(`${serverBaseUrl}/${relativeEndpoint}`, {
    headers: { Authorization: `Bearer ${token}` },
    cache: "no-store",
  });
  if (!res.ok) {
    throw new Error(`Could not load media (${res.status})`);
  }
  const blob = await res.blob();
  return URL.createObjectURL(blob);
}

export function revokeBlobUrl(url) {
  if (url && String(url).startsWith("blob:")) {
    try {
      URL.revokeObjectURL(url);
    } catch {
      /* ignore */
    }
  }
}
